import { Component } from '@theme/component';
import { ThemeEvents, QuantitySelectorUpdateEvent } from '@theme/events';

/**
 * Displays volume pricing table with expandable rows.
 * Shows pricing tiers based on quantity thresholds.
 *
 * @extends {Component}
 */
class VolumePricingComponent extends Component {
  connectedCallback() {
    document.addEventListener(ThemeEvents.quantitySelectorUpdate, (event) =>
      this.onQuantityChange(event)
    );
  }
  /**
   * Toggles the expanded state of the volume pricing table
   */
  toggleExpanded() {
    this.classList.toggle('volume-pricing--expanded');
  }

  /**
   * Handles QuantitySelectorUpdateEvent change event.
   * @param {QuantitySelectorUpdateEvent} event - The event.
   */

  onQuantityChange(event) {
    const quantity = event.detail.quantity;
    const rows = this.querySelectorAll('.volume-pricing__row');
    if (rows.length === 0) return;
    rows.forEach((row) => row.classList.remove('active'));
    rows.forEach((row) => {
      const min = row?.dataset?.quantityBreakMin;
      const max = row?.dataset?.quantityBreakMax;

      if (min && max) {
        if (quantity >= Number(min) && quantity <= Number(max)) {
          row.classList.add('active');
        }
      } else if (min && !max) {
        if (quantity >= Number(min)) {
          row.classList.add('active');
        }
      }
    });
  }
}

if (!customElements.get('volume-pricing')) {
  customElements.define('volume-pricing', VolumePricingComponent);
}
